export const TOGGLE_SUBCATEGORY_NAVIGATION =
  'BEAMLY/CCX/TOGGLE_SUBCATEGORY_NAVIGATION';

export const toggle = () => ({
  type: TOGGLE_SUBCATEGORY_NAVIGATION,
});
